module.exports = __webpack_public_path__ + "static/media/400054_01.b95e0b23.png";